import { render } from "./ThePatientAddressFieldset.vue?vue&type=template&id=4b5f1622&ts=true"
import script from "./ThePatientAddressFieldset.vue?vue&type=script&lang=ts"
export * from "./ThePatientAddressFieldset.vue?vue&type=script&lang=ts"

import "./ThePatientAddressFieldset.vue?vue&type=style&index=0&id=4b5f1622&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__